module.exports = __webpack_public_path__ + "927e1fb1081c6fd48202272fc0884caf.png";


//////////////////
// WEBPACK FOOTER
// ./res/images/backgrounds/carousel/qello/7.png
// module id = 854
// module chunks = 0